/* Cancellations report options */
export default {
  computed: {
    sortOptions () {
      return [
        {
          id: 1,
          name: 'Member',
          order: ['memberHostGuest:ASC', 'reservationId:ASC', 'memberId:DESC', 'guestHostId:DESC']
        }
      ]
    },
    detailGroupingOptions () {
      return [
        {
          id: 1,
          name: 'Members',
          subTitle: 'Members'
        }
      ]
    },
    groupingOptions () {
      return [
        {
          id: 1,
          name: 'Members',
          group: [
            {
              by: ['memberHostGuest', 'ASC'],
              showAggregates: true,
              aggregateLabel: (row, rowIndex, rows) => this.getMemberHostGuestName(row) + ' Total',
              caption: (row, rowIndex, rows) => {
                return this.getMemberHostGuestName(row)
              }
            },
            {
              by: ['reservationId'],
              newBody: true,
              bodyClass: ['ft-report-flat-group']
            }
          ],
          fields: ['memberHostGuest']
        }
      ]
    },
    columnOptions () {
      return this.baseColumnOptions.filter(c => ![18].includes(c.id)) // Exclude meal period name column
    }
  },
  methods: {
    isConsolidated (row) {
      return false
    },
    getNameFromItem (item) {
      return item.name
    },
    getMemberHostGuestName (r) {
      var nameParts = (r.memberHostGuest || '').split('|')
      if (!nameParts.length) return 'Unknown'
      if (nameParts[0] === '{UG}') {
        return (nameParts[2] || '') + '(Unaccompanied ' + nameParts[1] + ')'
      } else {
        return nameParts[0]
      }
    }
  }
}
